"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CasedObject = exports.snakeCase = exports.sentenceCase = exports.pathCase = exports.pascalCase = exports.paramCase = exports.noCase = exports.headerCase = exports.dotCase = exports.constantCase = exports.capitalCase = exports.camelCase = exports.changeCase = exports.Case = void 0;
const change_case_object_1 = __importStar(require("./change-case-object"));
exports.changeCase = change_case_object_1.default;
Object.defineProperty(exports, "Case", { enumerable: true, get: function () { return change_case_object_1.Case; } });
const { camel, capital, constant, dot, header, no, param, pascal, path, sentence, snake } = change_case_object_1.Case;
const camelCase = (x) => change_case_object_1.default(camel, x);
exports.camelCase = camelCase;
const capitalCase = (x) => change_case_object_1.default(capital, x);
exports.capitalCase = capitalCase;
const constantCase = (x) => change_case_object_1.default(constant, x);
exports.constantCase = constantCase;
const dotCase = (x) => change_case_object_1.default(dot, x);
exports.dotCase = dotCase;
const headerCase = (x) => change_case_object_1.default(header, x);
exports.headerCase = headerCase;
const noCase = (x) => change_case_object_1.default(no, x);
exports.noCase = noCase;
const paramCase = (x) => change_case_object_1.default(param, x);
exports.paramCase = paramCase;
const pascalCase = (x) => change_case_object_1.default(pascal, x);
exports.pascalCase = pascalCase;
const pathCase = (x) => change_case_object_1.default(path, x);
exports.pathCase = pathCase;
const sentenceCase = (x) => change_case_object_1.default(sentence, x);
exports.sentenceCase = sentenceCase;
const snakeCase = (x) => change_case_object_1.default(snake, x);
exports.snakeCase = snakeCase;
class CasedObject {
    constructor(value, { case: c } = {}) {
        this._value = {};
        Object.assign(this, { _value: !!c ? change_case_object_1.default(c, value) : value });
    }
    changeCase(to) {
        Object.assign(this, { _value: change_case_object_1.default(to, this._value) });
        return this._value;
    }
    get value() {
        return this._value;
    }
    set value(x) {
        Object.assign(this, { _value: x });
    }
    get camelCase() {
        return this.camelCase(this._value);
    }
    get capitalCase() {
        return this.capitalCase(this._value);
    }
    get constantCase() {
        return this.constantCase(this._value);
    }
    get dotCase() {
        return this.dotCase(this._value);
    }
    get headerCase() {
        return this.headerCase(this._value);
    }
    get noCase() {
        return this.noCase(this._value);
    }
    get paramCase() {
        return this.paramCase(this._value);
    }
    get pascalCase() {
        return this.pascalCase(this._value);
    }
    get pathCase() {
        return this.pathCase(this._value);
    }
    get sentenceCase() {
        return this.sentenceCase(this._value);
    }
    get snakeCase() {
        return this.snakeCase(this._value);
    }
}
exports.CasedObject = CasedObject;
CasedObject.camelCase = exports.camelCase;
CasedObject.capitalCase = exports.capitalCase;
CasedObject.constantCase = exports.constantCase;
CasedObject.dotCase = exports.dotCase;
CasedObject.headerCase = exports.headerCase;
CasedObject.noCase = exports.noCase;
CasedObject.paramCase = exports.paramCase;
CasedObject.pascalCase = exports.pascalCase;
CasedObject.pathCase = exports.pathCase;
CasedObject.sentenceCase = exports.sentenceCase;
CasedObject.snakeCase = exports.snakeCase;
exports.default = {
    Case: change_case_object_1.Case,
    changeCase: change_case_object_1.default,
    camelCase: exports.camelCase,
    capitalCase: exports.capitalCase,
    constantCase: exports.constantCase,
    dotCase: exports.dotCase,
    headerCase: exports.headerCase,
    noCase: exports.noCase,
    paramCase: exports.paramCase,
    pascalCase: exports.pascalCase,
    pathCase: exports.pathCase,
    sentenceCase: exports.sentenceCase,
    snakeCase: exports.snakeCase,
    CasedObject
};
//# sourceMappingURL=index.js.map